import cartItems from './slice.cart'
import checkoutTax from './slice.checkoutTax'
import checkoutValidation from './slice.checkout'
import checkoutRates from './slice.checkoutRates'
import checkoutSessionToken from './slice.checkoutSessionToken'
import featureFlags from './slice.featureFlags'
import integrations from './slice.integrations'
import storeViews from './slice.storeViews'

export default { cartItems, checkoutRates, checkoutSessionToken, checkoutTax, checkoutValidation, featureFlags, integrations, storeViews }
